import React from 'react';
import env from 'env';

export function MediaSelector({ form, fieldName, data }) {

  const field = form.findControl(fieldName);
  //console.log(field, fieldName)

  React.useLayoutEffect(() => {
    const handleMessage = (e) => {
      //console.log(e);
      var action = e.data.action;
      var onSelection = e.data.onSelection;
      var data = e.data.data;

      if (action === 'media-selected') {
        const fldName = onSelection.replace('selectedMediaFiles_', '')
        if (fldName === fieldName) {
          selectedMediaFiles(data);
        }        
      }
    }
    window.addEventListener('message', handleMessage)

    return () => window.removeEventListener('message', handleMessage)
    // eslint-disable-next-line
  }, [])

  function openLibrary(e) {
    const defPath = '/sites/cuisinart/media/information-booklets';
    var url = (env.cmsEndpoint) + `/cms41helper/browse/selectmedia?onSelection=selectedMediaFiles_${fieldName}&defPath=${defPath}&maxSelect=1`;
    var w = window.innerWidth;
    var h = window.innerHeight;
    window.open(url, 'cms_library', `toolbar=yes,scrollbars=yes,resizable=yes,top=${w * 0.05},left=${h * 0.05},width=${w * 0.9},height=${h * 0.9}`);

  }

  function selectedMediaFiles(items) {
    //const field = form.findControl(fieldName);
    if (!field) return;

    console.log(items)
    let obj = items;

    field.value = field.value || '';
    if (obj.items.length > 0) {
      field.value = obj.items[0].WebPath
    }
    form.reset()
  }

  return (
    <div>

      <button type="button" className="btn btn-warning" onClick={(e) => openLibrary(e)}>Open Media Library</button>
    </div>
  );
}